module.exports = __webpack_public_path__ + "static/media/html.4196766f.svg";